const ua = window ? window.navigator.userAgent : '';

const isIE = ua.indexOf('compatible') > -1 && ua.indexOf('MSIE') > -1; // 判断是否IE<11浏览器

const isEdge = ua.indexOf('Edge') > -1 && !isIE; // 判断是否IE的Edge浏览器
const isIE11 = ua.indexOf('Trident') > -1 && ua.indexOf('rv:11.0') > -1;
const OldIE = isIE && !isEdge && !isIE11;

// 判断移动终端设备，这里预留方法，以备不时之需
const isSafari = ua.indexOf('Safari') !== -1 && ua.indexOf('Version') !== -1;
const isIphone = ua.indexOf('iPhone') !== -1 && ua.indexOf('Version') !== -1;
const isIPad = isSafari && !isIphone && 'ontouchend' in document;
const device = {
  trident: ua.indexOf('Trident') > -1, // 移动IE
  presto: ua.indexOf('Presto') > -1, // opera内核
  webKit: ua.indexOf('AppleWebKit') > -1, // 苹果、谷歌
  gecko: ua.indexOf('Gecko') > -1 && ua.indexOf('KHTML') === -1, // 火狐内核
  mobiles: !!ua.match(/AppleWebKit.*Mobile.*/), // 移动终端
  ios: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios
  android: ua.indexOf('Android') > -1, // Android
  iPhone: isIphone, // ua.indexOf('iPhone') > -1, // iphone或者QQ浏览器
  iPad: ua.indexOf('iPad') > -1, // iPad
  webApp: ua.indexOf('Safari') === -1, // web应用程序
  safari: isSafari,
  newIPad: isIPad,
};

const { mobiles, iPad, newIPad, ios, android, iPhone } = device;
const mobile = mobiles || ios || android || iPhone;

const isPad = iPad || newIPad;

// eslint-disable-next-line max-len
const isPhoneExp =
  /iphone|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|android|iPod/i;
const isPhone = isPhoneExp.test(navigator.userAgent.toLowerCase());

export { isIE, OldIE, device, isPad, mobile, isPhone };
